import { token_user } from '../../config/tokenConstant';

export const checkRGPD = (): boolean => {
  return JSON.parse(localStorage.getItem(token_user)).gdpr_consent;
};
